export const SwiperButtonNext = () => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="20" cy="20" r="20" fill="#707E95" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.7141 26.2796C17.9716 26.5646 18.4191 26.5643 18.676 26.2789L24.1775 20.1691C24.52 19.7888 24.52 19.2112 24.1775 18.8309L18.733 12.7844C18.4455 12.4651 17.9451 12.4647 17.6571 12.7835C17.408 13.0593 17.408 13.4789 17.6571 13.7547L22.5444 19.1648C22.7163 19.3552 22.7163 19.6448 22.5444 19.8352L17.7141 25.1822C17.4326 25.4939 17.4326 25.968 17.7141 26.2796Z"
				fill="white"
			/>
		</svg>
	)
}
